/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../axios-client";
import type { PostApiBarberShiftBookMutationRequest, PostApiBarberShiftBookMutationResponse, PostApiBarberShiftBook400, PostApiBarberShiftBook401, PostApiBarberShiftBook403, PostApiBarberShiftBook404, PostApiBarberShiftBook500 } from "../entities/PostApiBarberShiftBook";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { postApiBarberShiftBook } from "../api/postApiBarberShiftBook";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const postApiBarberShiftBookMutationKey = () => [{ url: '/api/barber/shift/book' }] as const

export type PostApiBarberShiftBookMutationKey = ReturnType<typeof postApiBarberShiftBookMutationKey>

export function postApiBarberShiftBookMutationOptions<TContext = unknown>(config: Partial<RequestConfig<PostApiBarberShiftBookMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = postApiBarberShiftBookMutationKey()
        return mutationOptions<PostApiBarberShiftBookMutationResponse, ResponseErrorConfig<PostApiBarberShiftBook400 | PostApiBarberShiftBook401 | PostApiBarberShiftBook403 | PostApiBarberShiftBook404 | PostApiBarberShiftBook500>, {data: PostApiBarberShiftBookMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ data }) => {
            return postApiBarberShiftBook(data, config)
          },
        })

}

/**
 * @description Забронировать смену на сегодня/завтра
 * @summary Забронировать смену
 * {@link /api/barber/shift/book}
 */
export function usePostApiBarberShiftBook<TContext>(options: 
{
  mutation?: UseMutationOptions<PostApiBarberShiftBookMutationResponse, ResponseErrorConfig<PostApiBarberShiftBook400 | PostApiBarberShiftBook401 | PostApiBarberShiftBook403 | PostApiBarberShiftBook404 | PostApiBarberShiftBook500>, {data: PostApiBarberShiftBookMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<PostApiBarberShiftBookMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? postApiBarberShiftBookMutationKey()

          const baseOptions = postApiBarberShiftBookMutationOptions(config) as UseMutationOptions<PostApiBarberShiftBookMutationResponse, ResponseErrorConfig<PostApiBarberShiftBook400 | PostApiBarberShiftBook401 | PostApiBarberShiftBook403 | PostApiBarberShiftBook404 | PostApiBarberShiftBook500>, {data: PostApiBarberShiftBookMutationRequest}, TContext>
          

          return useMutation<PostApiBarberShiftBookMutationResponse, ResponseErrorConfig<PostApiBarberShiftBook400 | PostApiBarberShiftBook401 | PostApiBarberShiftBook403 | PostApiBarberShiftBook404 | PostApiBarberShiftBook500>, {data: PostApiBarberShiftBookMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<PostApiBarberShiftBookMutationResponse, ResponseErrorConfig<PostApiBarberShiftBook400 | PostApiBarberShiftBook401 | PostApiBarberShiftBook403 | PostApiBarberShiftBook404 | PostApiBarberShiftBook500>, {data: PostApiBarberShiftBookMutationRequest}, TContext>
      
}